import { configureStore } from "@reduxjs/toolkit";
import appointmentSlice from "./features/appointment/slice";
import chatSlice from "./features/chat/slice";
import diagnosticsSlice from "./features/diagnostics/slice";
import roomSlice from "./features/room/slice";
import settingsSlice from "./features/settings/slice";
import uiSlice from "./features/ui/slice";
import userSlice from "./features/user/slice";

export const store = configureStore({
  reducer: {
    appointment: appointmentSlice,
    settings: settingsSlice,
    user: userSlice,
    room: roomSlice,
    chat: chatSlice,
    ui: uiSlice,
    diagnostics: diagnosticsSlice,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
